export default "__VITE_ASSET__DJ9fpbex__"